// extracted by css-extract-rspack-plugin
export default {"input":"ljlYST","container":"Ijtxal","group":"eUsOQ5","slot":"XZMwmo","caretWrapper":"gmcKKC","caret":"L3GJIh","caret-blink":"hslRDz","caretBlink":"hslRDz"};